<template>  
  <div class="gantt-container">
    <b-table-simple small bordered responsive>
      <b-thead>
        <b-tr>
          <b-th 
            sticky-column
            class="gantt-left-column text-secondary"
          >Изменения</b-th>
          <b-th
            v-for="hour in periodOfDates"
            :key="$moment(hour).valueOf()"
            class="gantt-column text-secondary"
          >
          {{ $moment(hour).format('DD.MM.YYYY') }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="(active, t_index, index) in activities"
          :key="t_index"
        >
          <b-th class="gantt-left-column" sticky-column>
            <p class="mb-1 mt-2 font-weight-bold" :title="`${active.length} изменений(ия)`">{{ t_index }} / {{ activities[t_index][0].user.name }}</p>
    
            <div class="gantt-group mb-2">
              <div
                v-for="act in active"
                :key="act.id"
                class="gantt-element"
              >
                {{ act.property_name }}: {{ act.property_value }}
              </div>
            </div>
          </b-th>
          <b-td
            v-for="hour in periodOfDates"
            :key="$moment(hour).valueOf()"
          >
            <template v-if="$moment(hour).format('DD.MM.YYYY') === $moment(t_index, ['DD.MM.YYYY', 'MM.DD.YYYY']).format('DD.MM.YYYY')">
              <div 
                class="gantt-graph-bar"
                :style="`background-color: ${colors[index]};`"
                :title="`Изменения сделаны ${t_index}`"
              >
                <div class="gantt-graph-text">
                  Изменений: {{ active.length }}
                </div>
              </div>
            </template> 
          </b-td>
        </b-tr>
      </b-tbody>
      <b-tfoot>
        <b-tr>
          <b-th variant="secondary" class="gantt-left-column" sticky-column>
            <div class="text-right font-weight-normal">
              Всего изменений: <span class="font-weight-bold">{{ summeryCountOfChanges }}</span>
            </div>
          </b-th>
          <b-td :colspan="periodOfDates.length ? periodOfDates.length : 1" variant="secondary"></b-td>
        </b-tr>
      </b-tfoot>
    </b-table-simple>
  </div>
</template>

<script>
import colorArray from '@/constants/colorArray';

export default {
  props: {
    orderStatusHistory: {
      type: Array,
      default: () => [],
    },
    activities: {
      type: Object,
      default: () => [],
    }
  },
  data() {
    return {
      colors: colorArray,
      periodOfDates: [],
      summeryCountOfChanges: 0
    }
  },
  mounted() {
    this.periodOfDates = this.getPeriodOfDates();
  },  
  methods: {
    sortDates() {
      let dates = [];
      for (let key in this.activities) {
        this.activities[key].forEach(act => dates.push(act.formatted_created_at));
        this.summeryCountOfChanges += this.activities[key].length;
      }

      let lastDayOfOrder = this.orderClosedDate();

      if (lastDayOfOrder) {
        let maxTemp = this.$moment(lastDayOfOrder, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
        if (maxTemp) {
          dates.push(maxTemp);
        } else {
          dates.push(this.$moment());
        }
      } else {
        dates.push(this.$moment());
      }

      return dates
    },
    getMinDate() {
      let min = this.sortDates().map(t => this.$moment(t, 'DD.MM.YYYY HH:mm'));
      return this.$moment.min(min);
    },
    getMaxDate() {
      let max = this.sortDates().map(t => this.$moment(t, 'DD.MM.YYYY HH:mm'));
      return this.$moment.max(max);
    },
    orderClosedDate() {
      let closeDate = '';

      this.orderStatusHistory.forEach((status) => {
        if (status.reference_status_id == 361 || status.reference_status_id == 362) {
          closeDate = status.created_at;
        }
      });

      return closeDate;
    },
    getPeriodOfDates() {
      const start = this.getMinDate();
      const end = this.getMaxDate();
      const dates = [this.$moment({ ...start })];

      while (start.date() !== end.date()) {
        start.add(1, 'day');
        dates.push(this.$moment({ ...start }));
      }
      return dates
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/components/ui/kanban/gantt.scss';
</style>